import React, { Component } from 'react';

const IrqMainTitle = ({ children }) => (
  <h2 className="irq-title">{children}</h2>
)

export default IrqMainTitle;
